import { render, staticRenderFns } from "./route-node-edit.vue?vue&type=template&id=20fb3bf9&scoped=true"
import script from "./route-node-edit.vue?vue&type=script&lang=js"
export * from "./route-node-edit.vue?vue&type=script&lang=js"
import style0 from "./route-node-edit.vue?vue&type=style&index=0&id=20fb3bf9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb3bf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fb3bf9')) {
      api.createRecord('20fb3bf9', component.options)
    } else {
      api.reload('20fb3bf9', component.options)
    }
    module.hot.accept("./route-node-edit.vue?vue&type=template&id=20fb3bf9&scoped=true", function () {
      api.rerender('20fb3bf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main-data/route-node/route-node-edit.vue"
export default component.exports